export default {
    createNewMember: 'Create New Member',
    firstName: 'First Name',
    lastName: 'Last Name',
    userName: 'Username',
    password: 'Password',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    thisFieldIsRequired: 'This field is required',
    incorrectPhoneNubmer: 'Incorrect phone nubmer',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    branch: 'Branch',
    role: 'Role',
    save: 'Save',
    emailIsRequired: 'E-mail is required',
    invalidEmailFormat: 'Invalid e-mail format',
    emailIsExceededCharacters: 'E-mail is exceeded 255 characters',
    congratulation: 'Congratulation',
    errorMessage: 'Error Message',
    updateUserInfo: 'Edit User Info',
    userIsUpdate: 'User is updated',
    userIsCreated: 'User is created',
    cannotHaveSpace: 'This field is required(No Space)',
    cannotHaveSharp: 'This field must be not included "#" character'
}
